import axios from 'axios'

import { baseApi } from '../consts/consts'
import { IUseDataQueryParams, LoadDataRequest, TracingFilter } from '../types/Api'

export const queryDataHandler = async ({
  nameOfFile,
  paginationModel = {
    page: 0,
    pageSize: 0,
  },
  sort,
  appliedUniqueColumns,
  appliedFilters,
  known,
}: IUseDataQueryParams) => {
  const filters: TracingFilter[] = Object.entries(appliedFilters).map(([field, value]) => ({
    field,
    value: field === 'relevant' ? value === 'true' : field === 'type' ? +value : value,
    op: ['type', 'relevant'].includes(field) ? 'determined_attr' : 'regex',
  }))
  if (known === 'known' || known === 'unknown') {
    filters.push({
      field: 'known',
      value: known === 'known',
      op: 'determined_attr',
    })
  }

  const requestBody: LoadDataRequest = {
    name: nameOfFile,
    filters,
    uniqueness: appliedUniqueColumns,
    page: {
      offset: paginationModel.page * paginationModel.pageSize,
      limit: paginationModel.pageSize,
      order_by: sort.sortField,
      order_desc: sort.sortDir === 'desc',
    },
  }

  const { data } = await axios.post(`${baseApi}/table/load`, requestBody)
  return data
}
